import { Directive, inject, type OnInit } from '@angular/core';
import { Organizations } from '@core/auth/organizations';
import Keycloak from 'keycloak-js';
import { FRESHDESK_FAQS } from './freshdesk.constants';

declare global {
  interface Window {
    fwSettings: {
      widget_id: string;
    };
    FreshworksWidget: any;
  }
}

@Directive({
  selector: 'app-freshdesk',
  standalone: true,
})
export class FreshdeskComponent implements OnInit {
  private readonly authService = inject(Keycloak);

  ngOnInit() {
    const userProfile = this.authService.tokenParsed;
    const isSMM = userProfile?.organization?.includes(Organizations.SMM);

    this.loadFreshDesk(isSMM ? FRESHDESK_FAQS.SMM : FRESHDESK_FAQS.DEFAULT);
  }

  loadFreshDesk(widgetID: string) {
    window.fwSettings = {
      widget_id: widgetID,
    };

    () => {
      if ('function' !== typeof (window as any).FreshworksWidget) {
        const n = ((...args: any[]) => {
          n.q.push(args);
        }) as any;
        n.q = [];
        (window as any).FreshworksWidget = n;
      }
    };
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://euc-widget.freshworks.com/widgets/${widgetID}.js`;
    document.getElementsByTagName('head')[0].appendChild(script);
  }
}
